import type { AllowedTracingUrls } from '@anchorage/datadog-rum';

/**
 * Origins clientdashboard serves this app from. It also serves `/graphql`,
 * `/v1/` and `/v3/` off the same router, so every traced request is
 * same-origin and the page origin is what the matchers see.
 *
 * Anchorage and Porto are one deployment behind different hosts, and
 * production breaks the `anchorage-<env>.com` shape on both. The `pr-<N>`
 * label covers per-PR development deploys (`DEPLOY_PR` in
 * `@anchorage/next/server/frontoffice`).
 *
 * The port group is required before the terminator: `host:443@evil.example`
 * parses as userinfo, so a bare `:` would let any host impersonate ours.
 */
export const CLIENT_DASHBOARD_TRACING_URLS: AllowedTracingUrls = [
  {
    match:
      /^https:\/\/clientdashboard\.(?:pr-\d+\.)?anchorage-(?:development|staging)\.com(?::\d+)?(?:\/|$)/,
    propagatorTypes: ['tracecontext'],
  },
  {
    match: /^https:\/\/anchoragelogin\.com(?::\d+)?(?:\/|$)/,
    propagatorTypes: ['tracecontext'],
  },
  {
    match:
      /^https:\/\/dashboard\.(?:dev\.|staging\.|prod\.)?porto\.xyz(?::\d+)?(?:\/|$)/,
    propagatorTypes: ['tracecontext'],
  },
];
